import { Divider, DividerProps } from '@mui/material';

/**
 * The rule between two blocks of a form section. Its 32-pixel margins and
 * hand-picked grey were written for masks with far more air than a PALO one:
 * six of them made the contact block twice as long as it needed to be.
 */
export const SectionDivider = (props: DividerProps) => (
    <Divider sx={{ m: theme => theme.spacing(2.5, 0), borderColor: theme => theme.palette.divider }} {...props} />
);
